<template>
  <v-app id="inspire" class="background-svg" :style="backgroundStyle">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs11 sm6 md4>
            <v-card class="elevation-12 pb-10 px-4 pt-5" min-width="400">
              <v-card-title
                class="text-center d-flex flex-column justify-center"
              >
                <div class="justify-center">
                  <v-img
                    :src="API_BASE_URL+'/web_front/icon_logo.svg'"
                    class="logo-svg"
                  ></v-img>
                </div>
                <br />
                <div>
                  <span>Forgot Password</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="user.email"
                    name="email"
                    label="Email"
                    outlined
                    dense
                    type="text"
                     v-validate="'required|email'"
                    :error="
                      errors.first('email') != null ||
                      serverSideErrors.email != null
                    "
                    :error-messages="
                      errors.first('email') || serverSideErrors.email
                    "
                  ></v-text-field>
                </v-form>
              </v-card-text>
                <v-row>
                  <v-col cols="12" class="px-6">
                    <router-link  to="/superadmin/login" class="text-decoration-none">
                       Back To Login
                    </router-link>
                  </v-col>    
                </v-row>
                <v-row>
                  <v-col cols="12" class="px-6">
                    <v-btn block color="primary" @click="sendEmail" :loading="loading"> Submit </v-btn>
                  </v-col>
                </v-row>
            </v-card>
          </v-flex>
          <Alert />
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Alert from "../../Alert.vue";
import "@/assets/style.css";
import { mapMutations } from "vuex";

export default {
  components: {
    Alert,
  },
  data() {
    return {
      user: {
        email: "",
      },
      loading: false,
      serverSideErrors: {},
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${process.env.VUE_APP_API_URL}/web_front/bulding.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center' ,
        height: '100vh' ,
      };
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    sendEmail() {
      let _self = this;
      
       this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;

          _self.$axios.post("/superadmin/forgotPassword", this.user).then((response) => {
            let data = response.data;
            _self.loading = false;

            if (data.status) {
              _self.setAlert({
                showAlert : true,
                message : data.message,
                variant : 'green accent-4',
                timeout : 2000
              });
              this.$router.push({ path: "/superadmin/login" });
            } else {
              if (data.errors) {
                for (let i = 0; i < data.errors.length; i++) {
                  _self.serverSideErrors = {};
                  _self.serverSideErrors[data.errors[i].field] = data.errors[i].message;
                }
              } else {
                this.setAlert({
                  showAlert: true,
                  variant: "red accent-3",
                  timeout: "2000",
                  message: data.message,
                });
              }
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>


.logo-svg {
  width: 150px !important;
}
</style>